import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";

import { useRouter } from "@faire/retailer/app/_lib/routing/useRouter";

import { FILTERS_QUERY_PARAM_KEY, PAGE_QUERY_PARAM_KEY } from "../consts";

export const useServerCompatibleSDUIFilterablePaginatedSectionState = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const updateFilters = useCallback(
    (newFilterKeys: string[]) => {
      const queryParams = new URLSearchParams(searchParams);

      if (newFilterKeys.length > 0) {
        queryParams.set(FILTERS_QUERY_PARAM_KEY, newFilterKeys.join(","));
      } else {
        queryParams.delete(FILTERS_QUERY_PARAM_KEY);
      }

      // changing filters means different results, so go back to first page
      queryParams.delete(PAGE_QUERY_PARAM_KEY);

      const queryParamsString = queryParams.toString();
      if (queryParamsString) {
        router.push(pathname + "?" + queryParamsString);
      } else {
        router.push(pathname);
      }
    },
    [pathname, router, searchParams]
  );

  return { updateFilters };
};
